import { Injectable } from '@angular/core';

import { ScreenCategory } from '../../../shared';

@Injectable({
  providedIn: 'root',
})
export class AppImagesService {
  private categoryImagesMap: Map<ScreenCategory, string> = new Map();
  private cityImagesMap: Map<string, string> = new Map();

  constructor() {
    this.setCategoryImagesMap();
    this.setCityImagesMap();
  }

  private setCategoryImagesMap(): void {
    this.categoryImagesMap.set(
      'Accommodation',
      'https://images.unsplash.com/photo-1553444836-bc6c8d340ba7?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2700&q=80'
    );
    this.categoryImagesMap.set(
      'Arts',
      'https://images.unsplash.com/photo-1585483657205-e30968feac0e?ixid=MXwxMjA3fDB8MHxzZWFyY2h8NTB8fGFydHN8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60'
    );
    this.categoryImagesMap.set(
      'Drinks & Nightlife',
      'https://images.unsplash.com/photo-1532634922-8fe0b757fb13?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1352&q=80'
    );
    this.categoryImagesMap.set(
      'Events & Entertainment',
      'https://images.unsplash.com/photo-1470229538611-16ba8c7ffbd7?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
    );
    this.categoryImagesMap.set(
      'Finances',
      'https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80'
    );
    this.categoryImagesMap.set(
      'Food & Eat',
      'https://images.unsplash.com/photo-1562280963-8a5475740a10?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTF8fHNob3B8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60'
    );
    this.categoryImagesMap.set(
      'Government',
      'https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
    );
    this.categoryImagesMap.set(
      'Medical',
      'https://images.unsplash.com/photo-1580281658223-9b93f18ae9ae?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
    );
    this.categoryImagesMap.set(
      'Outdoors',
      'https://images.unsplash.com/photo-1604039620116-e405e98dbaa0?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1622&q=80'
    );
    this.categoryImagesMap.set(
      'Service',
      'https://images.unsplash.com/photo-1581042067809-35ac4c077da2?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1267&q=80'
    );
    this.categoryImagesMap.set(
      'Shops',
      'https://images.unsplash.com/photo-1542045904-23b645536536?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
    );
    this.categoryImagesMap.set(
      'Sport & Wellness',
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
    );
    this.categoryImagesMap.set(
      'Transport',
      'https://images.unsplash.com/photo-1534371293734-fdbda1e75f9a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1345&q=80'
    );
    this.categoryImagesMap.set(
      'Hospital',
      'https://images.unsplash.com/photo-1596541223130-5d31a73fb6c6?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1951&q=80'
    );
  }

  public getCategoryImagesMap(): Map<ScreenCategory, string> {
    return this.categoryImagesMap;
  }

  private setCityImagesMap(): void {
    this.cityImagesMap.set(
      'Agra',
      'https://images.unsplash.com/photo-1508196476590-9511757a5cbf?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1351&q=80'
    );
    this.cityImagesMap.set(
      'Delhi',
      'https://images.unsplash.com/photo-1600258881621-796a58df721e?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
    );
    this.cityImagesMap.set(
      'Indore',
      'https://qph.fs.quoracdn.net/main-qimg-8acf9e7ab7f3f6694e1cdb43cb4ea636'
    );
    this.cityImagesMap.set(
      'Jaipur',
      'https://images.unsplash.com/photo-1477587458883-47145ed94245?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'
    );
    this.cityImagesMap.set(
      'South Delhi',
      'https://cdn.pixabay.com/photo/2017/10/06/06/08/lotustemple-2822076_1280.jpg'
    );
    this.cityImagesMap.set(
      'Bhopal',
      'https://cdn.pixabay.com/photo/2010/12/13/09/52/bhopal-1853_1280.jpg'
    );
    this.cityImagesMap.set(
      'Pune',
      'https://cdn.pixabay.com/photo/2019/03/16/11/27/pune-4058851_1280.jpg'
    );
    this.cityImagesMap.set(
      'Hyderabad',
      'https://cdn.pixabay.com/photo/2015/08/19/15/41/charminar-896162_1280.jpg'
    );
    this.cityImagesMap.set(
      'Chennai',
      'https://cdn.pixabay.com/photo/2020/08/03/01/40/building-5458938_1280.jpg'
    );
  }

  public getCityImagesMap(): Map<string, string> {
    return this.cityImagesMap;
  }
}
